<template>
  <div class="header">
    <StateModal v-model="stateModal" />

    <div v-if="board" class="left section">
      <EnhancedQSelect
        :value="selectedBoardId"
        :options="boardOptions"
        :loading="!boards"
        label="Board"
        dense
        @input="boardChanged"
      />
    </div>

    <div v-if="board" class="right section">
      <div class="participants">
        <div
          v-for="participant of board.participants"
          :key="participant.id"
          :class="{ active: activeParticipantsIds.includes(participant.id) }"
          :style="{ background: participant.color }"
          class="participant"
          @click="toggleParticipants(participant.id)"
        >
          {{
            participant.name
              .split(' ')[0]
              .slice(0, 1)
              .toUpperCase()
          }}
          <template v-if="participant.name.split(' ').length > 1">
            {{
              participant.name
                .split(' ')[1]
                .slice(0, 1)
                .toUpperCase()
            }}
          </template>
          <LmTooltip> {{ participant.name }} </LmTooltip>
        </div>
      </div>

      <q-btn size="0.8rem" color="tertiary" @click="stateModal = true">New State</q-btn>

      <q-btn size="0.8rem" color="tertiary" to="/todo-templates">
        Manage Templates
        <LmTooltip> Go to todo templates page </LmTooltip>
      </q-btn>

      <q-btn size="0.8rem" color="tertiary" to="/kanban-boards">
        Manage Boards
        <LmTooltip> Go to boards page </LmTooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
// Components
import StateModal from './StateModal'
import EnhancedQSelect from '@/components/general/EnhancedQSelect'

export default {
  components: {
    EnhancedQSelect,
    StateModal
  },

  props: {
    board: Object
  },

  data: () => ({
    stateModal: false
  }),

  computed: {
    ...mapState('kanban-board', ['activeParticipantsIds', 'boards']),

    selectedBoardId() {
      return Number(this.$route.params.id)
    },

    boardOptions() {
      if (!this.boards) return []
      return this.generateOptions({
        collection: this.boards,
        sortBefore: true,
        sort: false,
        sortingOptions: {
          sortDataType: 'string',
          sortBy: 'name',
          sortOrder: 'asc'
        }
      })
    }
  },

  created() {
    this.getAndSetBoards()
  },

  methods: {
    ...mapMutations('kanban-board', ['toggleParticipants']),
    ...mapActions('kanban-board', ['getAndSetBoards', 'fetchBoard']),

    boardChanged(boardId) {
      this.$router.push(`/kanban-boards/${boardId}`)
      this.fetchBoard(boardId)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'
.header {
  display grid
  grid-template-columns 1fr 1fr
  align-items start

  .left.section {
    display grid
    font-size 0.875rem
    justify-content start

    span:first-child {
      color #2f5e80
    }
    span:last-child {
      font-weight 500
      color #25405b
    }
  }

  .right.section  {
    display grid
    justify-content end
    grid-auto-flow column
    align-items center
    gap 10px

    .participants {
      display grid
      grid-template-columns repeat(auto-fit, 30px)
      justify-content end
      padding 0 10px
      max-width 450px
      user-select none

      .participant {
        position relative
        border-radius 50%
        width 40px
        height 40px
        display flex
        justify-content center
        align-items center
        border 2px solid white
        color white
        font-weight 500
        font-size 0.875rem
        cursor pointer
        transition transform .2s ease-in-out
        animation fadeInScaleIn 350ms ease-in-out both;

        &.active {
          &:before {
            content ''
            width 122%
            height 122%
            position absolute
            top -4px
            left -4px
            border-radius 50%
            border 2px solid #59CD90
          }
        }

        for num in (1..5) {
          &:nth-child({num}) {
            animation-delay: 100ms * num;
          }
        }

        &:hover {
          z-index 1
          transform translateY(-4px)
        }

      }
    }
  }
}

@keyframes fadeInScaleIn {
  from {
    opacity 0
    transform scale(0.6) translateY(-8px)
  }

  to {
    opacity 1
  }
}
</style>
